var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebpushBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4446 13.0687L16.866 10.7008V2.60078C16.866 1.60898 16.056 0.800781 15.066 0.800781H4.26602C3.27512 0.800781 2.46602 1.60898 2.46602 2.60078V10.7008L0.887416 13.0687C0.666016 13.4008 0.666016 13.5925 0.666016 13.8508V14.3008C0.666016 14.7508 1.11602 15.2008 1.56512 15.2008H17.7669C18.216 15.2008 18.666 14.7508 18.666 14.3008V13.8508C18.666 13.5925 18.666 13.4008 18.4446 13.0687ZM6.96602 13.4008L7.50602 12.5008H11.826L12.366 13.4008H6.96602ZM15.066 9.80078H4.26602V2.60078H15.066V9.80078Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpushBlue);
export default __webpack_public_path__ + "static/media/webpushBlue.6422eb5b4170a956a11d2ed69f8d117f.svg";
export { ForwardRef as ReactComponent };